import React from "react";
import { Container, Paper, Typography, Button, Box, Alert } from "@mui/material";
import RestaurantIcon from '@mui/icons-material/Restaurant';
import RefreshIcon from '@mui/icons-material/Refresh';
import HomeIcon from '@mui/icons-material/Home';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an unhandled error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = "/recipes";
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              textAlign: "center",
              borderRadius: 4,
              bgcolor: "#faf7f2",
              border: "1px solid #e0dbd1"
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <RestaurantIcon sx={{ fontSize: 60, color: '#D28415' }} />
            </Box>

            <Typography
              variant="h4"
              gutterBottom
              sx={{ fontFamily: "'Patrick Hand', cursive", color: "#477491" }}
            >
              Something Simmered Over!
            </Typography>

            <Typography variant="body1" color="textSecondary" paragraph>
              An unexpected error occurred while loading this page. Don't worry, your recipes and family data are safe.
            </Typography>

            {process.env.NODE_ENV !== "production" && this.state.error && (
              <Alert severity="error" sx={{ textAlign: "left", my: 2, overflowX: "auto" }}>
                <strong>{this.state.error.toString()}</strong>
              </Alert>
            )}

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
              <Button
                variant="contained"
                onClick={this.handleReload}
                startIcon={<RefreshIcon />}
                sx={{ bgcolor: "#D28415", "&:hover": { bgcolor: "#b36b10" }, fontWeight: "bold" }}
              >
                Reload Page
              </Button>
              <Button
                variant="outlined"
                onClick={this.handleGoHome}
                startIcon={<HomeIcon />}
                sx={{ borderColor: "#477491", color: "#477491" }}
              >
                Go to Recipes
              </Button>
            </Box>
          </Paper>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
